<!--TODO: ésta vista no esta activa-->
<template>
	<el-container id="historial">
		<el-row type="flex" justify="center">
			<el-col :xs="24" :sm="23" :md="22" :lg="21" :xl="18">
				<p>Historial de pedidos</p>
				<el-table
					v-loading="loadinghistorial"
					element-loading-text="Cargando historial de pedidos"
					:data="pedidos"
					size="mini"
					fit="true"
					style="width: 100%;"
					empty-text=" No hay pedidos en el historial"
				>
					<el-table-column width="30px" type="expand" fixed>
						<template v-slot="{ row }">
							<el-row v-for="item in row.productos" :key="item.renglon_id">
								<el-col :span="3"><el-image style="width: 50px; height: 50px;" :src="item.url[0]"></el-image></el-col>
								<el-col :span="6"
									><div>
										Producto: <b> {{ item.descripcion }}</b>
										<p>
											<el-badge v-if="item.es_nuevo" value="Nuevo" class="mark"></el-badge
											><el-badge v-if="item.es_promocion" value="Promo" class="mark"></el-badge>
										</p></div
								></el-col>
								<el-col :span="6"
									><div>
										Cantidad: <b> {{ item.pedido_cantidad }}</b>
									</div></el-col
								>
								<el-col :span="6"
									><div>
										Precio: <b> ${{ item.precio_final }}</b>
									</div></el-col
								>
								<br />
								<br />
								<el-divider></el-divider>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column fixed>
						<template v-slot="{ row }"
							><b>Pedido número: {{ row.id }}</b></template
						>
					</el-table-column>
					<el-table-column fixed>
						<template v-slot="{ row }">Fecha: {{ row.fecha | formatDate }}</template>
					</el-table-column>
					<el-table-column fixed width="200px"
						><template v-slot="{ row }">Detalle: {{ row.detalle }} </template>
					</el-table-column>
					<el-table-column fixed width="200px"
						><template v-slot="{ row }">Origen: {{ row.origen_descripcion }} </template>
					</el-table-column>
					<el-table-column fixed width="200px"
						><template v-slot="{ row }">Destino: {{ row.destino_descripcion }} </template>
					</el-table-column>
					<el-table-column prop="total" fixed width="200px"
						><template v-slot="{ row }">Total: ${{ row.total }}</template>
					</el-table-column>
					<el-table-column fixed="right"
						><template v-slot="{ row }"
							><el-button @click="repetir(row)" size="mini" icon="el-icon-refresh-right"> Repetir compra</el-button></template
						>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row type="flex" justify="center" v-if="pedidos">
			<el-pagination small layout="prev, pager, next" :page-size="limit" :total="totalpedidos" @current-change="changepage"> </el-pagination>
		</el-row>
		<carrito :visible="visibleCarrito" :cardactivo="activo"></carrito>
	</el-container>
</template>
<script>
import Carrito from '@/components/Carrito.vue';
import moment from 'moment';
export default {
	components: { Carrito },
	name: 'historial',
	data() {
		return {
			loading: false,
			visibleCarrito: false,
			activo: 1,
			start: 0,
			limit: 8,
			page: 1,
			//pedidos: true,
		};
	},
	wach: {
		pedidos() {},
	},
	computed: {
		pedidos() {
			return this.$store.state.pedidos.pedidos;
		},
		carrito() {
			return this.$store.state.pedidos.carrito;
		},
		idcarrito() {
			return this.$store.state.pedidos.idcarrito;
		},
		totalpedidos() {
			return this.$store.state.totalpedidos;
		},
		loadinghistorial() {
			return this.$store.state.pedidos.loadinghistorial;
		},
	},
	filters: {
		formatDate: function (value) {
			if (!value) return '';
			return moment(String(value)).format('MM/DD/YYYY hh:mm');
		},
	},
	methods: {
		updateEntrega() {
			let condiciones = [];
			condiciones['dentrega'] = this.entrega;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putDentrega', condiciones);
		},
		updateOrigen() {
			let condiciones = [];
			condiciones['origen'] = this.origen;
			condiciones['pedido_id'] = this.idcarrito;
			this.$store.dispatch('putOrigen', condiciones);
		},
		changepage(ps) {
			this.start = ps * this.limit - this.limit;
			this.page = ps;
			this.callPedidos();
		},
		callPedidos() {
			let filtros = this.filter,
				start = this.start,
				limit = this.limit,
				page = this.page,
				pedidos = true;
			this.$store.dispatch('loadPedidos', { params: { filtros, start, limit, page, pedidos } });
		},
		repetir(row) {
			if (this.carrito.length > 0) {
				this.$alert('Tine productos en su carrito, por favor eliminelos.', 'Carrito de compras cargado', {
					confirmButtonText: 'OK',
					callback: action => {
						this.visibleCarrito = !this.visibleCarrito;
					},
				});
			} else {
				this.loading = true;
				this.activo = 3;
				let condiciones = [];
				condiciones['dentrega'] = row.destino_id;
				condiciones['origen'] = row.origen_id;
				condiciones['pedido_id'] = this.idcarrito;
				condiciones['detalle'] = row.detalle ? row.detalle : '';
				this.$store.dispatch('putDetalle', condiciones);
				this.$store.dispatch('putDentrega', condiciones);
				this.$store.dispatch('putOrigen', condiciones);
				row.productos.forEach(producto => {
					producto.pedido_id = this.idcarrito;
					this.$store.dispatch('addProducto', producto).then(result => {
						this.loading = false;
					});
				});
				this.visibleCarrito = !this.visibleCarrito;
			}
		},
	},
	mounted() {
		this.callPedidos();
	},
};
</script>
<style></style>
